import classNames from 'clsx';
import { Children } from 'react';

import type { PropsWithChildren } from 'react';

import styles from './ButtonGroup.module.css';

export interface ButtonGroupProps {
  /** true to render the buttons from top to bottom; otherwise, false. The default is false. */
  stacked?: boolean;
  /** true to render the buttons in reverse order; otherwise, false. The default is false. */
  reversed?: boolean;
}

/** Represents a component that contains a group of buttons. */
export const ButtonGroup = ({ children, stacked, reversed }: PropsWithChildren<ButtonGroupProps>) =>
  // only render a <ButtonGroup> when there are children
  Children.count(children) > 0 ? (
    <div
      className={classNames(styles['button-group'], {
        [styles['button-group--stacked']]: stacked,
        [styles['button-group--reversed']]: reversed,
        [styles['button-group--reversed-stacked']]: stacked && reversed,
      })}
    >
      {children}
    </div>
  ) : null;
